/* veyra — Hero carousel: crossfade slides + dots + optional autoplay. */
(function () {
  function init(root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-dot]'));
    if (slides.length < 2) return;
    var idx = 0, timer = null;
    var autoplay = root.getAttribute('data-autoplay') === 'true';
    var interval = parseInt(root.getAttribute('data-interval'), 10) || 6000;

    function show(n) {
      idx = (n + slides.length) % slides.length;
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === idx); });
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
    }
    dots.forEach(function (d, i) { d.addEventListener('click', function () { show(i); restart(); }); });

    function restart() {
      if (!autoplay) return;
      if (timer) clearInterval(timer);
      timer = setInterval(function () { show(idx + 1); }, interval);
    }
    restart();
  }
  function boot() { document.querySelectorAll('veyra-hero').forEach(init); }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
